module.exports = __webpack_public_path__ + "assets/night.e23549e6.svg";